import { useContext, useEffect, useCallback } from "react";
import { LifecycleStagesContext } from "../providers/LifecycleStagesProvider";

/**
 * @param {string} [portalName] - "Cm"
 *
 */
export default function useLifecycleStages(portalName = "Cm") {
  const context = useContext(LifecycleStagesContext);

  if (context === undefined || context === null) {
    throw new Error(
      "useLifecycleStages must be used within a LifecycleStagesProvider",
    );
  }

  const {
    stagesByType,
    allStages,
    loading,
    error,
    loaded,
    fetchStages,
    getStages,
    getStageConfig: getStageConfigRaw,
    getLifecycleForResolution: getLifecycleRaw,
    ensureLoaded,
  } = context;

  useEffect(() => {
    if (!loaded && typeof ensureLoaded === "function") {
      ensureLoaded();
    }
  }, [loaded, ensureLoaded]);

  const getStageConfig = useCallback(
    (key, caseDetails = {}) => getStageConfigRaw(key, caseDetails, portalName),
    [getStageConfigRaw, portalName],
  );

  const getLifecycleForResolution = useCallback(
    (resolutionKind, rowsOverride) =>
      getLifecycleRaw(resolutionKind, portalName, rowsOverride),
    [getLifecycleRaw, portalName],
  );

  return {
    stagesByType,
    stages: allStages,
    allStages,
    loading,
    isLoading: loading,
    error,
    loaded,
    fetchStages,
    getStages,
    getStageConfig,
    getLifecycleForResolution,
    ensureLoaded,
  };
}
